import {
  EDELVIVES_DIGITAL_PLUS,
  GOTITBYME,
  MACMILLAN,
  SANTILLANA_BR_COMPARTIR,
  SANTILLANA_BR_UNOI,
  SANTILLANA_GT_COMPARTIR,
  SANTILLANA_HN,
} from './resourcesByTenant';
import { DEFAULT_RESOURCES_EN, DEFAULT_RESOURCES_ES, DEFAULT_RESOURCES_PT } from './resourcesDefault';

export default {
  //TRADUCCIONES POR DEFECTO
  es: DEFAULT_RESOURCES_ES,
  en: DEFAULT_RESOURCES_EN,
  pt: DEFAULT_RESOURCES_PT,
  //TRADUCCIONES POR TENANT
  ...GOTITBYME,
  ...MACMILLAN,
  ...SANTILLANA_GT_COMPARTIR,
  ...SANTILLANA_BR_COMPARTIR,
  ...SANTILLANA_BR_UNOI,
  ...SANTILLANA_HN,
  ...EDELVIVES_DIGITAL_PLUS,
};
